import { useLocation } from "react-router-dom";
import { BCLink } from "../../styled/global.styled";

const Breadcrumbs = () => {

  const location = useLocation();
  const parts = location.pathname.split("/").filter((part) => part); // Removes first # part
  let path = "";
  
  return (
    <nav id="breadcrumb" className="bc-breadcrumb" aria-label="breadcrumb">
      <ol>
        <li>
          <BCLink to="/">Inicio</BCLink>
        </li>
            {parts.map((part, index) => {
              // Append part to current path
              path += "/" + part;

              return (
                <li key={index}>
                    <BCLink key={`link${index}`} to={path}>{part}</BCLink>
                </li>
              );
            })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
